<template>
  <div>
    <v-dialog v-model="dialog" width="500" eager>
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="12" md="3">
            <rx-text-field
              :label="$t('common.lbl.postcode')"
              readonly
              v-model="innerValue.zonecode"
              v-bind="attrs"
              v-on="on"
              @click="getPostcode()"
              outlined
              hide-details="auto"
              :dense="dense"
            ></rx-text-field>
          </v-col>
          <v-col cols="12" md="9">
            <rx-text-field
              :label="$t('common.lbl.base_address')"
              readonly
              v-model="innerValue.roadAdd"
              v-bind="attrs"
              v-on="on"
              @click="getPostcode()"
              outlined
              hide-details="auto"
              :dense="dense"
            ></rx-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <rx-text-field
              :label="$t('common.lbl.detail_address')"
              v-model="innerValue.detail"
              :rules="rules"
              outlined
              hide-details="auto"
              :dense="dense"
            ></rx-text-field>
          </v-col>
        </v-row>
      </template>
      <v-card @click="dialog = false">
        <div :id="id"></div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script src="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"></script>
<script>
export default {
  props: {
    id: {
      type: String,
      default: "address",
    },
    value: {
      type: Object,
      // 예시 { "zonecode": "06000", "roadAdd": "서울 강남구 강남대로 708 (압구정동)", "roadAddress": "서울 강남구 강남대로 708", "roadExtraAddr": " (압구정동)", "jibunAddress": "서울 강남구 압구정동 386-1", "userSelectedType": "R", "detail": "상세주소입니다." }
    },
    rules: Object,
    dense: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      innerValue: {},
      dialog: false,
    };
  },
  methods: {
    getPostcode() {
      var me = this;
      this.dialog = true;
      const element_layer = document.getElementById(this.id);
      let address = {};
      new daum.Postcode({
        oncomplete: function(data) {
          // 각 주소의 노출 규칙에 따라 주소를 조합한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.

          // 우편번호
          let zonecode = data.zonecode;

          // 도로명 주소
          let roadAddress = ""; // 주소 변수
          let roadExtraAddr = ""; // 참고항목 변수

          //지번 주소
          let jibunAddress = "";

          //주소 타입에 따라 해당 주소 값을 가져온다.
          roadAddress = data.roadAddress;
          jibunAddress = data.jibunAddress;

          // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
          // 법정동명이 있을 경우 추가한다. (법정리는 제외)
          // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
          if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
            roadExtraAddr += data.bname;
          }
          // 건물명이 있고, 공동주택일 경우 추가한다.
          if (data.buildingName !== "" && data.apartment === "Y") {
            roadExtraAddr +=
              roadExtraAddr !== ""
                ? ", " + data.buildingName
                : data.buildingName;
          }
          // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
          if (roadExtraAddr !== "") {
            roadExtraAddr = " (" + roadExtraAddr + ")";
          }
          // 조합된 참고항목을 해당 필드에 넣는다.
          address.zonecode = zonecode;
          address.roadAdd = roadAddress + roadExtraAddr;
          address.roadAddress = roadAddress;
          address.roadExtraAddr = roadExtraAddr;
          address.jibunAddress = jibunAddress;
          address.userSelectedType = data.userSelectedType;

          me.dialog = false;
        },
      })
        //.open();
        .embed(element_layer);
      this.setInnerValue(address);
    },
    setInnerValue(address) {
      this.innerValue = address;
      this.$emit("input", address);
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style lang="scss" scoped></style>
